import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_SEND_BIOMETRIC_TERMS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const BiometricTermsPopup = ({ popupRef, onContinueIntro, ...props }) => {
    const { biometricDisclaimerDescription, biometricDisclaimerConsentButton, biometricDisclaimerRejectButton } = usePageMessages();

    const onClick = (e, confirmed) => {
        e.preventDefault();
        props.toggleSpinner(true);
        popupRef.current.close();
        apiFetchData(`${AUTH_SEND_BIOMETRIC_TERMS}?confirmed=${confirmed}`, null, null, {}, true)
            .then((_text) => {
                if (confirmed) {
                    onContinueIntro(e, true);
                }
            })
            .finally(() => {
                props.toggleSpinner(false);
            });
    };

    return (
        <SimplePopup text={MarkdownService.splitByParagraph(biometricDisclaimerDescription)} popupRef={popupRef}>
            <PopupButton title={biometricDisclaimerConsentButton} iconName="check" text={biometricDisclaimerConsentButton} onClick={(e) => onClick(e, true)} />
            <PopupButton title={biometricDisclaimerRejectButton} iconName="cross" text={biometricDisclaimerRejectButton} onClick={(e) => onClick(e, false)} />
        </SimplePopup>
    );
};
BiometricTermsPopup.propTypes = {
    popupRef: PropTypes.object.isRequired,
    onContinueIntro: PropTypes.func.isRequired,
};
export default connect(null, { toggleSpinner })(BiometricTermsPopup);
